import { Header } from '@rbilabs/universal-components';

export const StyledHeader = Header.withConfig({
  textAlign: 'center',
});
